const messages = {
  header: 'Gruppentraining / Firmentraining',
  title1: 'Stronger Together',
  paragraph1:
    'Sammle deine Freunde zusammen und lass uns zusammen trainieren! Denn in einer Gruppe trainieren sorgt für zusätzliche Motivation und macht Spass. Zeit, Ort und Ziel des Trainings könnt ihr selbst bestimmen. Ich berate eure Gruppe individuell und stelle sicher, dass jeder die Übungen richtig macht.',
}

export default messages
